// URLs now come from .env (see .env.example) — local/QA/staging are switched
// by commenting/uncommenting blocks in .env itself, mirroring the old scheme here.
exports.BASE_URL = process.env.REACT_APP_BASE_URL;
exports.ImageUrl = process.env.REACT_APP_IMAGE_URL;
exports.SignalRUrl = process.env.REACT_APP_SIGNALR_URL;

// Global Environment URL — runtime-computed (depends on the browser's current
// origin), so it can't be expressed as a static .env value. Uncomment and
// rebuild in place of the exports above if this deployment target is needed.
// exports.BASE_URL = `${window.location.origin}/backend/api/`;
// exports.ImageUrl = `${window.location.origin}/backend/images/`;
// exports.SignalRUrl = `${window.location.origin}/backend/hubs`;

// The claim the access token carries the role in. Not `role`: the API builds its tokens with
// `new JwtSecurityToken(claims: ...)` from `ClaimTypes.Role`, and that constructor writes claim
// types verbatim - the short-name mapping only runs on the token handler's descriptor path. So
// the payload key is the full URI, and `decoded.role` is undefined on every token the server
// issues. Deliberately not in .env: it is fixed by the API's code and the same in every
// environment, and a build missing the key would read every role as undefined and lock every
// user out of the role-gated routes.
exports.ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

exports.LOGIN_API = "Account/Login";
exports.FORGET_API = "Account/ResetPassword";
exports.COMMON_REDEEM_PROMOCODE = "Common/RedeemPromoCode";
exports.COMMON_GENERATE_PROMOCODE = "Common/GeneratePromoCode";
exports.REFRESH_TOKEN_API = "Account/RefreshToken";
exports.LOGOUT_API = "Account/Logout";
exports.AUCTION_AUCTIONDATABYFILTER = "Auction/AuctionDataByFilter";
exports.LINK_VERIFY_API = "Account/EmailLinkConfirmation";
exports.UPDATE_PASSWORD_API = "Account/ResetPasswordConfirmation";
exports.CHANGE_PASSWORD_API = "Account/ChangePassword";
exports.EMAIL_EXISTS = "Account/CheckEmailExists";
exports.ORGANIZATION_REGISTRATION_API = "Manager/Add";
exports.ORGANIZATION_GETALL_API = "Manager/GetAll";
exports.ORGANIZATION_Delete_API = "Manager/DeleteBy/";
exports.ORGANIZATION_ViewID_API = "Manager/GetBy/";
exports.ORGANIZATION_Update_API = "Manager/update";
exports.ORGANIZATION_Country_API = "Common/countries";
exports.ORGANIZATION_State_API = "Common/states/";
exports.ORGANIZATION_City_API = "Common/cities/";
exports.ORGANIZATION_GetRecent = "Manager/GetRecent";
exports.ORGANIZATION_TotalCount = "Manager/GetCount";
exports.USER_REGISTRATION_API = "Player/Add";
exports.USER_TotalCount = "Player/GetCount";
exports.USER_GetAll = "Player/GetAll";
exports.USER_GETID = "Player/GetBy/";
exports.SPORTS_REGISTRATION_API = "Sports/Add";
exports.UPLOAD_IMAGE = "Common/UploadImage";
exports.NOTIFICATION_MESSAGE_REG = "Announcement/CreateNotification";
exports.SPORTS_UPDATE = "Sports/Update";
exports.SPORTS_GETALL = "Sports/GetAll";
exports.SPORTS_GETID = "Sports/GetBy/";
exports.SPORTS_DELETE = "Sports/Delete/";
exports.SPORTS_Total = "Sports/GetCount";
exports.WEB_ADMIN_PROFILE = "Common/UpdateProfile";
exports.TEAM_GETALL_API = "Team/GetAll";
exports.TEAM_REG_API = "Team/Add";
exports.TEAM_DELETE_API = "Team/Delete/";
exports.TEAM_TOTAL_API = "Team/GetCount";
exports.TEAM_UPDATE_API = "Team/Update";
exports.TOURNAMENT_REG = "Tournament/Add";
exports.TOURNAMENT_GET = "Tournament/GetAll";
exports.TOURNAMENT_GET_RECENT = "Tournament/GetRecent";
exports.TOURNAMENT_DELETE = "Tournament/Delete/";
exports.TOURNAMENT_GET_COUNT = "Tournament/GetCount";
exports.TOURNAMENT_GET_ID = "Tournament/GetBy/";
// Batch 4.1 (#82/#83/#84/#85): bracket system disabled - these endpoints no longer exist on the
// API. TOURNAMENT_GET_ID_BRACKETS was already dead: "Tournament/Bracket/" has never had a route.
// exports.TOURNAMENT_GET_ID_BRACKETS = "Tournament/Bracket/";

// exports.TOURNAMENT_BRACKETS_ID = "Tournament/GetTournamentBracketById/";

exports.TOURNAMENT_UPDATE = "Tournament/Update";
exports.AUCTION_REG = "Auction/Add";
exports.AUCTION_GET_ALL = "Auction/GetAll";
exports.AUCTION_GET_COUNT = "Auction/GetCount";
exports.AUCTION_DELETE_API = "Auction/Delete/";
exports.AUCTION_UPDATE = "Auction/Update";
exports.AUCTION_GETBYID = "Auction/GetBy";
exports.AUCTION_RECENT = "Auction/GetRecent";
exports.PRACTICE_MANAGER_EMAIL = process.env.REACT_APP_PRACTICE_MANAGER_EMAIL;
exports.GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
exports.FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
exports.TERMLY_NOTICE_ID = process.env.REACT_APP_TERMLY_NOTICE_ID;
exports.ZIP_LOOKUP_URL = process.env.REACT_APP_ZIP_LOOKUP_URL;
exports.BID_GET_COUNT = "Bid/GetCount";
exports.AUCTION_UPDATE = "Auction/Update";
exports.AUCTION_SHOWPLACEBID = "Auction/WinnerPercentage"
exports.NOTIFICATION_MESSAGE = "Announcement/GetNotification";
exports.REG_BID = "Bid/Add";
exports.SMREG_BID = "SecondaryMarket/SMPlaceBid";
exports.CUSTOMER_ADD = "Customer/Add";
exports.PAYMENT_ADD = "Payment/Add";
exports.AUCTIONGETTEAM = "Auction/GetAuctionTeams";
exports.AUCTIONWININGCOUNT = "Auction/WinnerCount";
exports.TEAMGETBYSPORT = "Team/GetTeamsBySportsId/";
exports.GETBIDBYMANAGER = "Bid/GetBidsbyManagerId";
exports.GETALL_BID = "Bid/GetAll";
exports.RECENT_BID = "Bid/GetRecent";
exports.CREATEPAYMENTURL =
  "Stripe/CreateCustomerAndPaymentSession?subscriptionId";
exports.CHECKOUTPAYMENTSTATUS = "Stripe/GetPaymentStatus";

// Disabled together with /WebAdmin/AccountHistory (WEB-72). The endpoint returns every user's Stripe
// rows with no ownership filter, and that page was its only caller in any client.
// exports.PAYMENTHISTORY = "Stripe/GetAllPaymentHistory";
exports.ADMIN_GET = "Manager/GetAdmin";
exports.BID_STATUS = "Bid/GetBidWithStatus";
// Batch 4.1: bracket system disabled.
// exports.BRACKETSUFFLE = "Tournament/SuffleTeams";
exports.ADMIN_REGISTER = "Manager/RegisterAdmin";
exports.ANNOUNCEMENT_GETALLAUCTION = "Announcement/GetAllAuctionAnnouncement";
exports.ANNOUNCEMENT_GETANNOUNCEMENTDATA =
  "Announcement/GetAnnouncementByAuctionId";
exports.MANAGER_GETBYID = "Manager/GetById";
exports.GETBYIDPAYMENT = "Stripe/GetUserPaymentHistory";
exports.GETSUBSCRIPTIONDETAILS = "Stripe/GetUserSubscriptionDetails";
exports.CANCELAUTORENEW = "Stripe/CancelAutoRenew";
// One-time access to a single auction. The server decides what is on offer and owns every
// message shown to the player, so these are only ever called with an auction id.
exports.AUCTIONPASS_OPTIONS = "Stripe/GetAuctionPassOptions";
exports.AUCTIONPASS_SESSION = "Stripe/CreateAuctionPassSession";
exports.AUCTIONPASS_REDEEM = "Stripe/RedeemAuctionPassCredit";
exports.BID_GETBIDWITHSTATUS = "Bid/GetBidWithStatus";
exports.BID_GETBIDWITHSTATUS = "Bid/GetBidWithStatus";
exports.SECODARY_MARKETAUCTION = "SecondaryMarket/SMGetAllWinAuction";
exports.SECODARY_MARKETAUCTION_SMGETAUCTIONBYID =
  "SecondaryMarket/SMGetAuctionById";
exports.SECODARY_MARKETAUCTION_WINNER = "SecondaryMarket/SMGetAllAuction";
// Batch 4.1: bracket system disabled. The no-bracket equivalents - UpdatePlayerMatchScore and
// UpdatePlayerMatchDate, reached through GET_TOURNAMENT_TEAM_MATCH below - are unaffected.
// exports.TOURNAMENT_BRACKETS_UPDATE = "Tournament/UpdateMatchScore";
// exports.TOURNAMENT_BRACKETS_DATE = "Tournament/UpdateMatchDate";
exports.AUCTION_AUCTIONPLAYPAUSESTATUS = "Auction/AuctionPlayPauseStatus";
exports.CONTACTUS = "Common/ContactUs";
exports.CONTACTUSDETAILS = "Common/GetContactUsDetails";
exports.INVOICEDETAILS = "Common/GetInvoiceReport";
exports.PLAYER_GET_REQUESTABLE_MANAGERS = "Player/GetRequestableManagers";
// #133: the Managers page, the Discover Managers widget and their subscribe/cancel actions.
exports.PLAYER_GET_MANAGERS = "Player/GetManagers";
exports.PLAYER_GET_MANAGER_COUNTS = "Player/GetManagerCounts";
exports.PLAYER_SUBSCRIBE_MANAGERS = "Player/SubscribeManagers";
exports.PLAYER_CANCEL_MANAGER_REQUEST = "Player/CancelManagerRequest";
// #199: a Player deleting their own account - what it affects, then the request itself.
exports.PLAYER_DELETION_IMPACT = "Player/GetDeletionImpact";
exports.PLAYER_REQUEST_DELETION = "Player/RequestAccountDeletion";
// A Player's broadcast email switches: every Manager's (Account Settings) and one Manager's (My
// Managers), and the unsubscribe link in every broadcast email (called without signing in).
exports.PLAYER_GET_EMAIL_SETTINGS = "Player/GetEmailSettings";
exports.PLAYER_UPDATE_EMAIL_SETTINGS = "Player/UpdateEmailSettings";
exports.PLAYER_UPDATE_MANAGER_EMAILS = "Player/UpdateManagerEmails";
exports.UNSUBSCRIBE_DETAILS = "Unsubscribe/Details";
exports.UNSUBSCRIBE_CONFIRM = "Unsubscribe/Confirm";
// Email verification: whether the signed-in account's email is verified (the banner) and the
// banner's "Verify email" button; the emailed link's page and the sign-in refusal's "Resend", both
// called without signing in.
exports.ACCOUNT_GET_EMAIL_VERIFICATION = "Account/GetEmailVerification";
exports.ACCOUNT_SEND_VERIFICATION_EMAIL = "Account/SendVerificationEmail";
exports.ACCOUNT_VERIFY_EMAIL = "Account/VerifyEmail";
exports.ACCOUNT_RESEND_VERIFICATION_EMAIL = "Account/ResendVerificationEmail";
// #234: cancelling a deletion request - by the player at sign-in (anonymous, Login's body and answer),
// or by the Web Admin from the Players list.
exports.ACCOUNT_CANCEL_DELETION = "Account/CancelAccountDeletion";
exports.PLAYER_ADMIN_CANCEL_DELETION = "Player/AdminCancelAccountDeletion";
// #218: Player/SubscribeManager (one Manager at a time) is no longer published; every request goes
// through PLAYER_SUBSCRIBE_MANAGERS, which notifies each Manager.
exports.SECODARY_MARKETAUCTION_SMBIDSELL = "SecondaryMarket/SMBidSell";
exports.MANAGER_GETPLAYERREQUEST = "Manager/GetPlayerRequest";
exports.MANAGER_PLAYERAPPROVAL = "Manager/PlayerApproval";
exports.PLAYER_GETSUBSCRIBE_MANAGER = "Player/GetSubscribedManager";
// #236: the Player's Auctions list, one row per auction.
exports.PLAYER_AUCTIONS = "Player/GetAuctions";
exports.PLAYER_AUCTION_DETAILS = "Player/GetAuctionDetails";
// #239: Recent Bids on the Auction Details page, the five newest bids of one lot.
exports.PLAYER_LOT_RECENT_BIDS = "Player/GetLotRecentBids";
exports.GETBIDWINNER = "Bid/GetMyBidWinings";
exports.GETBIDCOUNTDATA = "Bid/GetCount";
exports.SECONDARYBIDH = "SecondaryMarket/SMBidHistory";
exports.BID_GETAUCTION_TEAMWINNER = "Bid/GetAuctionTeamWinner";
exports.SUBCRIPTIONREVENUE = "Common/GetSubscriptionRevenue";
exports.SECODARY_MARKETAUCTION_ANNOUNCEMENT = "SecondaryMarket/SMAnnouncement";
exports.ANNOUNCEMENT_GETWINNERDEATILS = "Announcement/GetWinnerDetails";
// MG-012 / AD-012: the Winners page (Manager and Admin) and its auction filter.
exports.ANNOUNCEMENT_GETWINNERS = "Announcement/GetWinners";
exports.ANNOUNCEMENT_GETWINNERSAUCTIONS = "Announcement/GetWinnersAuctions";
// MG-003.1: saves the Team Buyback marks of one auction on Auction Results.
exports.ANNOUNCEMENT_UPDATETEAMBUYBACK = "Announcement/UpdateTeamBuyback";
// #196: the Player bell's unread count, and marking it read when the Notifications page opens.
exports.ANNOUNCEMENT_GETUNREADNOTIFICATIONS = "Announcement/GetUnreadNotifications";
exports.ANNOUNCEMENT_MARKNOTIFICATIONSSEEN = "Announcement/MarkNotificationsSeen";
// MG-014 / AD-013 (#167, #168): the Broadcasting Center (Manager and Admin).
exports.BROADCAST_GETRECIPIENTS = "Broadcast/GetRecipients";
exports.BROADCAST_SEND = "Broadcast/Send";
exports.BROADCAST_GETBROADCASTS = "Broadcast/GetBroadcasts";
exports.BROADCAST_GETBYID = "Broadcast/GetBroadcastById";
exports.REPORTDATAAPI = "Common/GetSubscriptionCount";
exports.GET_BID_AMOUNT_REPORT = "Player/GetBidAmountReport";
exports.SUBSCRIPTION_CONT = "Common/GetSubscriptionCount";
exports.SM_MY_BID_HISTORY = "SecondaryMarket/SMMyBidHistory";
exports.GET_TOURNAMENT_TEAM_MATCH = "Tournament/GetTournamentTeamMatch/";
exports.TOURNAMENT_UPDATE_PLAYER_MATCH_DATE =
  "Tournament/UpdatePlayerMatchDate";
exports.TOURNAMENT_UPDATE_PLAYER_MATCH_SCORE =
  "Tournament/UpdatePlayerMatchScore";
exports.COMMON_GET_PROMOCODES = "Common/GetPromoCodes";
